var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10 text-4xl font-bold w-3/4 mx-auto"})}
var staticRenderFns = []

export { render, staticRenderFns }